import { isNullOrWhiteSpace } from "../fable_modules/fable-library-js.4.29.0/String.js";
import { create, isMatch } from "../fable_modules/fable-library-js.4.29.0/RegExp.js";

/**
 * Validate whether a given string is a valid name. Allows all alpha characters, space and hyphen.
 */
export function isValidName(name) {
    if (!isNullOrWhiteSpace(name)) {
        return isMatch(/^\p{Lu}\p{L}{0,49}([ '-]\p{L}{1,49})*$/gu, name);
    }
    else {
        return false;
    }
}

/**
 * Validates an input string is a valid email address.
 */
export function isValidEmail(email) {
    if (isNullOrWhiteSpace(email)) {
        return false;
    }
    else {
        return isMatch(create("^[a-zA-Z0-9._%+-]+@(?:[A-Za-z0-9](?:[A-Za-z0-9-]{0,61}[A-Za-z0-9])?\\.)+[A-Za-z]{2,}$"), email);
    }
}

//# sourceMappingURL=Validators.jsx.map
